import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.224 12.258H4.567V4.602h7.657zm.785-9.224H3.782A.783.783 0 0 0 3 3.82v9.224c0 .433.352.782.782.782h9.227a.78.78 0 0 0 .782-.782V3.819a.78.78 0 0 0-.782-.785m-.785 22.364H4.567v-7.656h7.657zm.785-9.223H3.782a.783.783 0 0 0-.782.782v9.223c0 .436.352.785.782.785h9.227a.78.78 0 0 0 .782-.785v-9.223a.78.78 0 0 0-.782-.782m12.424-3.917h-7.657V4.602h7.657zm.785-9.224H16.99a.78.78 0 0 0-.782.785v9.224a.78.78 0 0 0 .782.782h9.227a.78.78 0 0 0 .782-.782V3.819a.78.78 0 0 0-.782-.785Zm-1.144 16.883h-2.649v-2.649a1.326 1.326 0 0 0-1.328-1.328 1.32 1.32 0 0 0-.934.39c-.25.25-.39.586-.39.938v2.649h-2.651c-.35 0-.689.14-.935.39a1.324 1.324 0 0 0 .935 2.262h2.652v2.652a1.328 1.328 0 0 0 2.262.938c.25-.25.39-.59.39-.938v-2.652h2.648a1.325 1.325 0 0 0 0-2.652"
    }, null, -1)
  ]))]))
}
export default { render: render }